import { empty } from "../../../constants/placeholders"

/**
 * `specialization`, `location` and `cslb_classification` are typed as arrays
 * but do not always arrive as one — `SubcontractorsList/columns.tsx` has
 * carried an `Array.isArray` guard for exactly these fields since before
 * EAD-1322. Anything that maps or joins one of them needs the same guard, or
 * a single string from the API takes the page down with
 * "specialization.map is not a function".
 */
export const asArray = (value?: string[] | string | null): string[] => {
  if (Array.isArray(value)) return value
  return value ? [value] : []
}

/** The same values rendered as one readable line, or the shared placeholder. */
export const asList = (value?: string[] | string | null): string =>
  asArray(value).join(", ") || empty
